import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  TextField,
} from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../../hooks";
import { removeSelectedArticle, clearSelectedArticles, updateArticleQuantity, updateArticleCommentaire } from "../slices/articleStandardSlice";
import { savePrecommande } from "../slices/precommandeSlice";
import { Article } from "../slices/articleStandardSlice";
import { useTranslation } from "react-i18next";
import { openSnackbar } from "../../../redux/slices/snackbarSlice";
import { formatPrice } from "../../../utils/formatPrice";

interface ArticleWithQuantity extends Article {
  quantity: number;
  commentaire?: string;
  typeArticle?: string;
  id:string;
}

const CustomListArticlesSelected = () => {
  const dispatch = useAppDispatch();
  const selectedArticles = useAppSelector(
    (state) => state.articleStandardSlice.selectedArticles
  ) as ArticleWithQuantity[];
  const { client, siteExpedition, siteVente } = useAppSelector((state) => state.preOrderFilterSlice);

  const { t } = useTranslation();
  const { totalPrice } = useAppSelector((state) => state.articleStandardSlice);
  const { direction } = useAppSelector((state) => state.languageSlice)

  const handleRemoveClick = (id: string) => {
    dispatch(removeSelectedArticle(id));
  };
  

  const handleClearAll = () => {
    dispatch(clearSelectedArticles());
  };

  const handleSend = () => {
    const articlesToSend = selectedArticles.map(article => ({
      reference: article.Reference,
      description: article.Description,
      unite: article.Unite,
      prix: article.price ?? 0,
      quantite: article.quantity,
       Commentaire: article.commentaire || "",
       typeArticle: article.typeArticle ,
       
    }));

    const precommandeData = {
      clientId: client?.NumeroClient,
      siteVenteId: siteVente?.Code,
      siteExpId: siteExpedition?.Code,
      articles: articlesToSend,
      userId: "",
      NameClient: client?.RaisonSociale,
    };

    dispatch(savePrecommande(precommandeData)).then((d) => {

      dispatch(openSnackbar({
        message: t("newPreOrder.messages.ok"),
        type: "success",
        horizontal: direction === 'rtl' ? 'left' : 'right'
      }));
      dispatch(clearSelectedArticles());
    }).catch(() => {
      dispatch(openSnackbar({
        message: t("newPreOrder.messages.noOk"),
        type: "error",
        horizontal: direction === 'rtl' ? 'left' : 'right'
      }));
    })
  };

  return (
    <Box>
      {selectedArticles.length > 0 ? (
        <>
    
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Référence</TableCell>
                  <TableCell align="center">Description</TableCell>
                  <TableCell align="center">Unité</TableCell>
                  <TableCell align="center">Quantité</TableCell>
                  <TableCell align="center">Commentaire</TableCell>
                  <TableCell align="center">Prix</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedArticles.map((article, index: number) => (
                  <TableRow key={index}>
                    <TableCell align="center">{article.Reference}</TableCell>
                    <TableCell align="center">{article.Description}</TableCell>
                    <TableCell align="center">{article.Unite}</TableCell>
                    <TableCell align="center">
                      <TextField
                        type="number"
                        value={article.quantity}
                        onChange={(e) => {
                          const newQuantity = parseInt(e.target.value) || 0;
                          dispatch(updateArticleQuantity({
                            id: article.id,
                            quantity: newQuantity
                          }));
                        }}
                        inputProps={{ min: 1 }}
                        size="small"
                        sx={{ width: 60, height: 30 }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <TextField
                        type="text"
                        value={article.commentaire || ""}
                        onChange={(e) => {
                          dispatch(updateArticleCommentaire({
                            id: article.id,
                            commentaire: e.target.value
                          }));
                        }}
                        size="small"
                        sx={{ width: 120 }}
                      />
                    </TableCell>


                    <TableCell align="center">{formatPrice(article.price ?? 0)}</TableCell>
                    <TableCell align="center">
                      <Button
                        size="small"
                        variant="contained"
                        color="error"
                        onClick={() => handleRemoveClick(article.id)}
                        sx={{
                          textTransform: "none",
                          borderRadius: "25px",
                          width: "50%",
                        }}
                      >
                        Retirer
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Typography variant="h6" align="right" sx={{ mt: 2, color: '#0D004C' }}>
            {`${formatPrice(totalPrice)} Dhs TTC`}
          </Typography>
          <Box display="flex" justifyContent="end" sx={{ mt: 2 }}>
            <Button
              variant="contained"

              onClick={handleClearAll}

              sx={{
                textTransform: "none",
                borderRadius: "25px",
                marginRight: "10px",
                width: "fit-content",
                backgroundColor: '#B41919',
                color: '#fff'
              }}
            >
              {t("newPreOrder.buttons.vider")}
            </Button>
            <Button
              variant="contained"

              onClick={handleSend}
              sx={{
                textTransform: "none",
                borderRadius: "25px",
                width: "fit-content"
              }}
            >
              {t("newPreOrder.buttons.envoyer")}
            </Button>
          </Box>
          {/* {status === 'loading' && <Typography align="center" sx={{ mt: 2 }}>Envoi en cours...</Typography>}
          {status === 'succeeded' && <Typography align="center" sx={{ mt: 2 }}>Précommande envoyée avec succès! ID: {precommandeId}</Typography>}
          {status === 'failed' && <Typography align="center" sx={{ mt: 2, color: 'red' }}>Erreur lors de l'envoi: {error}</Typography>} */}
        </>
      ) : (
        <Box
          sx={{
            border: '1px solid #E8EBFD',
            borderRadius: '8px',
            minHeight: '300px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h7">
            {t("newPreOrder.titles.videArticles")}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CustomListArticlesSelected;
